import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScalesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={16}
    fill="none"
    viewBox="0 0 20 16"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        d="m14.468 4.484-3.214 5.893h6.429zm-10.714 0L.54 10.377h6.428zm6.872-1.607a1.6 1.6 0 0 1-.38.599 1.6 1.6 0 0 1-.6.38v10.807h5.09q.117 0 .193.075a.26.26 0 0 1 .075.193v.536a.26.26 0 0 1-.075.192.26.26 0 0 1-.193.075H3.486a.26.26 0 0 1-.192-.075.26.26 0 0 1-.076-.193v-.535a.26.26 0 0 1 .076-.193.26.26 0 0 1 .192-.075h5.09V3.857a1.6 1.6 0 0 1-.6-.381 1.6 1.6 0 0 1-.38-.599h-4.11a.26.26 0 0 1-.192-.075.26.26 0 0 1-.076-.193v-.535a.26.26 0 0 1 .076-.193.26.26 0 0 1 .192-.075h4.11q.175-.477.586-.774.41-.298.93-.298.518 0 .928.298.41.297.586.774h4.11a.26.26 0 0 1 .193.075.26.26 0 0 1 .075.193v.535a.26.26 0 0 1-.075.193.26.26 0 0 1-.193.075zm-1.988-.063.098.099q.098.098.375.098a.65.65 0 0 0 .473-.197.65.65 0 0 0 .197-.472.65.65 0 0 0-.197-.473.65.65 0 0 0-.473-.197.65.65 0 0 0-.473.197.65.65 0 0 0-.197.473q0 .276.197.472m9.58 7.563q0 .611-.389 1.097-.39.485-.984.761-.594.277-1.21.415-.615.138-1.167.138T13.3 12.65a6 6 0 0 1-1.209-.415 2.7 2.7 0 0 1-.984-.761q-.39-.486-.389-1.097 0-.092.293-.678.293-.585.77-1.46.477-.876.896-1.637a236 236 0 0 1 1.322-2.377.5.5 0 0 1 .47-.276q.317 0 .468.276a293 293 0 0 1 2.218 4.014q.477.875.77 1.46.293.586.293.678m-10.714 0q0 .611-.39 1.097-.389.485-.983.761-.594.277-1.21.415-.615.138-1.167.138t-1.168-.138a6 6 0 0 1-1.21-.415 2.7 2.7 0 0 1-.983-.761q-.39-.486-.39-1.097 0-.092.294-.678.293-.585.77-1.46.477-.876.896-1.637a238 238 0 0 1 1.322-2.377.5.5 0 0 1 .469-.276q.318 0 .469.276A322 322 0 0 1 6.44 8.239q.477.875.77 1.46.293.586.293.678"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 15.734h19.09v-15H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgScalesIcon;
